import { cn } from '@/lib/utils';
import React, { useState } from 'react'
import { BsFillCaretDownFill } from 'react-icons/bs';

export default function FnoTermDropDown({ list, selected, onChange, className="" }) {
    const [active, setActive] = useState(false);
    return (
        <div className="relative inline-block text-left">
            {active && <div onClick={() => setActive(false)} className='fixed top-0 left-0 right-0 bottom-0 backdrop-blur-[0px] w-screen h-[200vh] z-40' />}
            <button onClick={() => setActive(pre => !pre)}
                type="button" className={cn("whitespace-nowrap inline-flex items-center max-w-[120px] justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50",className)} id="menu-button" aria-expanded="true" aria-haspopup="true">
                {selected}
                <BsFillCaretDownFill className='w-4 min-w-[16px]' />
            </button>
            <div className={`${active ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}
            absolute right-0 z-50 -mt-6 w-32 origin-top-right rounded bg-white shadow-lg border border-primary border-opacity-50 transition ease-out duration-200 divide-y`}
                role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                {list?.map(ele =>
                    <div onClick={() => {
                        onChange(ele)
                        setActive(false)
                    }}
                        key={ele} className={`${selected === ele ? 'font-semibold' : 'font-normal'} w-full px-3 py-2 flex items-center justify-between`}>
                        <div className=' text-black text-xs line-clamp-1'>{ele}</div>
                        {selected === ele ?
                            <div style={{ width: 16, height: 16, justifyContent: 'flex-start', alignItems: 'center', gap: 2.67, display: 'inline-flex' }}>
                                <div style={{ width: 16, height: 16, padding: 2.67, justifyContent: 'center', alignItems: 'center', gap: 2.67, display: 'flex' }}>
                                    <div style={{ width: 10.67, height: 10.67, background: '#F6F6F6', borderRadius: 9999, border: '3px #00439D solid' }} />
                                </div>
                            </div>
                            : <div style={{ width: 16, height: 16, justifyContent: 'flex-start', alignItems: 'center', gap: 2.67, display: 'inline-flex' }}>
                                <div style={{ width: 16, height: 16, padding: 2.67, justifyContent: 'center', alignItems: 'center', gap: 2.67, display: 'flex' }}>
                                    <div style={{ width: 10.67, height: 10.67, background: '#F6F6F6', borderRadius: 9999, border: '0.50px #747474 solid' }} />
                                </div>
                            </div>}
                    </div>
                )}
            </div>
        </div>
    )
}
